import React, { memo } from 'react';
import { Bar } from 'react-chartjs-2';

import './chart-setup';
import { UI } from '../../styled-comps';

// Stacked (or grouped) bar chart. `datasets` = [{ label, data: number[], color }].
const FunnelBarChart = memo(({ labels, datasets, stacked = true, showLegend = false }) => {
  const data = {
    labels,
    datasets: datasets.map(ds => ({
      label: ds.label,
      data: ds.data,
      backgroundColor: ds.color,
      stack: stacked ? 'stack-1' : undefined,
      borderRadius: 3,
      maxBarThickness: 46,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: showLegend
        ? { position: 'top', labels: { usePointStyle: true, pointStyleWidth: 8, padding: 16 } }
        : { display: false },
      tooltip: { mode: 'index', intersect: false },
    },
    scales: {
      x: {
        stacked,
        grid: { display: false },
        ticks: { maxRotation: 40, minRotation: 40 },
      },
      y: {
        stacked,
        beginAtZero: true,
        grid: { color: UI.borderLight },
      },
    },
  };

  return <Bar data={data} options={options} />;
});

export default FunnelBarChart;
